import React from 'react';
import { useFormContext } from 'react-hook-form';
import { ControlledFormInput } from '../../../../Lib/Utils/FormUtils/ControlledFormInput';
import { AddTagFormData } from '../types';
import { getCountryOptions } from '../constants';

interface FormSectionProps {
  domesticMerchPoEligible?: boolean;
}

export function LogisticsSection({
  domesticMerchPoEligible,
}: FormSectionProps) {
  const { control } = useFormContext<AddTagFormData>();
  const countryOptions = getCountryOptions(domesticMerchPoEligible);

  return (
    <div className="rounded-xl border border-neutral-200 shadow-sm p-5 space-y-4">
      <ControlledFormInput
        name="customCutLeadTime"
        label="Custom Cut Lead Time"
        control={control}
        inputType="number"
        required
        rules={{
          valueAsNumber: true,
          min: {
            value: 0,
            message: 'Lead time cannot be negative',
          },
          validate: (value) =>
            Number.isInteger(value) || 'Lead time must be a whole number',
        }}
        inputProps={{
          min: '0',
          step: '1',
          endAdornment: <span className="text-gray-500 text-sm">weeks</span>,
        }}
      />

      <div className="grid grid-cols-2 gap-4">
        <ControlledFormInput
          name="coo"
          label="COO"
          control={control}
          inputType="select"
          required
          inputProps={{
            placeholder: 'Select..',
            className: 'w-full',
            options: countryOptions.map((option) => ({
              label: option.label,
              value: option.label,
            })),
          }}
        />
        <ControlledFormInput
          name="shipmentMode"
          label="Shipment Mode"
          control={control}
          inputType="select"
          required
          inputProps={{
            placeholder: 'Select..',
            className: 'w-full',
            options: [
              { label: 'Air', value: 'Air' },
              { label: 'Sea', value: 'Sea' },
              { label: 'Land', value: 'Land' },
            ],
          }}
        />
      </div>
    </div>
  );
}
